import { takeEvery, call, put } from "redux-saga/effects";
import { GET_CATERING_SUBCAT, SET_CATERING_SUBCAT } from "../actions";
import { appId, apiUrlCtrng } from "../components/Helpers/Config";
import Axios from "axios";

export const watchGetSubCategory = function* () {
  yield takeEvery(GET_CATERING_SUBCAT, workerGetSubCategory);
};

function* workerGetSubCategory() {
  try {
    const uri = apiUrlCtrng + "catering/getSubcategoryList?app_id=" + appId;
    const result = yield call(Axios.get, uri);
    var resultArr = [];
    resultArr.push(result.data);
    yield put({ type: SET_CATERING_SUBCAT, value: resultArr });
  } catch {
    console.log("Get Sub Category Failed");
  }
}
